export const drawerProfile = {
	excludeTaxProfile: "Eliminar perfil",
	infoDataCompany: {
		CNPJ: "RFC",
		cityCode: "Código del municipio",
		corporateReason: "Razón social",
		fantasyName: "Nombre comercial",
		municipalRegistration: "Registro municipal",
		stateRegistration: "Registro estatal",
		taxRegime: "Régimen tributario",
		specialTaxRegime: "Régimen especial de tributación",
		hasCadastroNacionalContribuinte: "¿Tiene registro nacional de contribuyente?",
	},
	infoDataIvaVendus: {
		apikey: "Clave API",
		cashierIds: "IDs de las cajas",
		country: "País",
		payments: {
			cash: "Efectivo",
			credit: "Crédito",
			debit: "Débito",
			mbway: "Mbway",
			others: "Otros",
			paymentMethodId: "Forma de pago",
		},
	},
	infoDataNfce: {
		certificate: "Certificado",
		certificatePassword: "Contraseña del certificado",
		cscNfceHomologation: "CSC NFC-e homologación",
		cscNfceProduction: "CSC NFC-e producción",
		expirationDate: "Fecha de expiración",
		idNfceHomologation: "ID NFC-e homologación",
		idNfceProduction: "ID NFC-e producción",
	},
	infoDataSat: {
		serialNumberSat: "Número de serie SAT",
	},
	infoDataTax: {
		mode: "Modo fiscal",
	},
	infoManifestation: {
		manifestation: "Manifestación",
	},
	infoNationalService: {
		nationalService: "Serviço Nacional",
	},
	infosGeneralData: {
		email: "E-mail",
		phone: "Teléfono",
	},
	infosGeneralDataFiscalModeBR: {
		cep: "Código postal",
		county: "Ciudad",
		neighborhood: "Colonia",
		number: "Número",
		publicPlace: "Calle",
		state: "Estado",
	},
	infosTipConfig: {
		taxGroup: "Grupo Fiscal",
		registered: "Registrado",
	},
	titles: {
		companyData: "Datos de la empresa",
		generalData: "Datos generales",
		taxData: "Datos fiscales",
		tipConfig: "Configuración de propina",
	},
};
